<nav class="w-full bg-white text-gray-700 shadow-sm">
    <div class="mx-auto flex flex-wrap items-center justify-between px-4 py-2">
        <div>
            <a class="flex items-center">
                <img
                    [routerLink]="['/']"
                    src="assets/logo/hairstyleclub-full-logo.png"
                    class="h-8 w-auto cursor-pointer object-contain md:h-12"
                    alt="Hair Style Club" />
            </a>
        </div>
    </div>
</nav>
